<div #clearance class="clearance-probe" aria-hidden="true"></div>
<cdk-virtual-scroll-viewport
  data-header-scroll-fade
  customVirtualScrollStrategy
  class="mobile-list-viewport"
  role="list"
  [itemHeights]="itemHeights()"
  [attr.aria-busy]="loading() || loadingMore()"
  [attr.aria-hidden]="!rows().length && !headerTemplate() ? 'true' : null"
>
  <div
    *cdkVirtualFor="let row of renderRows(); let index = index; trackBy: trackRow"
    class="mobile-list-row"
    [awMobileListItem]="row.id"
    [pressDisabled]="row.auxiliary || row.kind === 'footer' || row.kind === 'clearance'"
    [class.mobile-list-row--highlighted]="row.highlighted"
    [class.mobile-list-row--divider]="row.divider"
    [class.mobile-list-row--header]="row.kind === 'header'"
    [class.mobile-list-row--auxiliary]="row.auxiliary || row.kind === 'footer' || row.kind === 'clearance'"
    [style.--mobile-list-indent]="(row.indent || 0) + 'px'"
    [style.--mobile-list-divider-inset]="row.dividerInset + 'px'"
    [style.height.px]="row.height"
    [attr.data-row-id]="row.id"
    [attr.role]="row.kind === 'list-header' || row.kind === 'footer' || row.kind === 'clearance' ? null : 'listitem'"
    [attr.aria-posinset]="
      row.kind === 'list-header' || row.kind === 'footer' || row.kind === 'clearance' ? null : index + 1 - headerRowCount()
    "
    [attr.aria-setsize]="
      row.kind === 'list-header' || row.kind === 'footer' || row.kind === 'clearance' ? null : hasMore() ? -1 : rows().length
    "
  >
    @if (row.kind === 'list-header') {
      <ng-container [ngTemplateOutlet]="headerTemplate()" />
    } @else if (row.kind === 'footer') {
      <div class="list-status">
        @if (loadMoreFailed()) {
          <span role="alert">{{ loadMoreError() }}</span>
          <button type="button" (click)="retry()">{{ translations.retry }}</button>
        } @else if (loadingMore()) {
          <span role="status">{{ loadingLabel() }}</span>
        }
      </div>
    } @else if (row.kind !== 'clearance' && rowTemplate(); as template) {
      <ng-container
        [ngTemplateOutlet]="template.template"
        [ngTemplateOutletContext]="{ $implicit: row.value, index: index - headerRowCount() }"
      />
    }
  </div>
</cdk-virtual-scroll-viewport>
@if (!rows().length) {
  <div class="list-state" [style.top.px]="headerTemplate() ? renderedHeaderHeight() : 0">
    @if (loading()) {
      <aw-list-skeleton />
      <span class="sr-only" role="status">{{ loadingLabel() }}</span>
    } @else if (emptyTemplate()) {
      <ng-container [ngTemplateOutlet]="emptyTemplate()" />
    }
  </div>
}
